import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`select-none max-w-watchesMax mx-auto`};
  padding-left: 50px;
  padding-right: 50px;

  .swiper {
    ${tw`overflow-visible`};
  }
`
